<template>
   <div style="margin-bottom:-10px">
       <v-app-bar  app>
      <v-row class="grey lighten-4" style="" >
    <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
      <router-link to="/">
         <img class=" ml-14 pt-1" :src="require('../assets/inlogo.png')" height="40"/>
      </router-link>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="mr-5 d-none d-lg-flex d-xl-none">
      <v-row>
        <v-spacer></v-spacer>
      
       
          <!-- <v-btn outlined class="mt-6 ml-4" small>{{totalprice.toFixed(2)}}</v-btn> -->
          <v-btn text    to="/cart"  class="mt-5">
             <v-icon   > mdi-shopping-outline </v-icon> ({{$store.state.cart.length}})
        </v-btn>
        <div v-if="admin=='true'">
            <v-btn  class="mt-6 ml-4" rounded outlined style="text-transform:none" to="/Dashboard" color="green">Dashboard </v-btn>
          
        </div>
          
         <span v-else>
            <v-btn v-if="!$store.state.auth " class="mt-6 ml-4" rounded outlined style="text-transform:none" to="/login" color="green">Sign in </v-btn>
          <v-btn v-if="!$store.state.auth" dark class="mt-6 ml-4" rounded  style="text-transform:none" to="/user/create" color="black">Join now </v-btn>
         </span>
           
           <v-menu v-if="$store.state.auth"   offset-y>
      <template v-slot:activator="{ on, attrs }">
          <v-btn  v-bind="attrs"
          v-on="on" class="mt-5 ml-4 text-caption" style="text-transform:none" text><v-icon>mdi-account</v-icon>Account</v-btn>
       
         
      </template>
      <v-list style="background-color:#efefef">
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          :to="item.to"
          
        >
          <v-list-item-title class="text-caption text-left">{{ item.title }}</v-list-item-title>
        </v-list-item>
        <v-list-item
         @click="signout"
          
        >
          <v-list-item-title class="text-caption text-left">Sign out</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
      </v-row>
    </v-col>
      </v-row>
  </v-app-bar>
   </div>
</template>

<script>
export default {
    data(){
    return{
         items: [
        { title: 'Card Management',to:'/' },
        { title: 'My Rewards',to:'/rewards' },
        { title: 'History',to:'/' },
        { title: 'Personal Info',to:'/' },
        { title: 'Payment Methods',to:'/' },
        { title: 'Settings',to:'/' },
        
      ],
      admin:localStorage.getItem("admin")
    }
    },
    methods:{
        signout(){
            localStorage.clear()
            this.$store.commit("setAuth",false)
            this.$router.push('/')
        }
    }
}
</script>

<style>

</style>